import React, {useState} from "react";
import { StyleSheet, Text, View, Button, Image,Dimensions, Alert} from "react-native";
import imgSrc from './images/info.jpg';
// import axios from 'axios';


// const translateText = async () => {
// 	try {
// 		alert('inside of fun');
// 		try {
// 			const response = await axios.get('https://example.com/api/data');
// 			alert('Axios Response:', response.data);
// 		  } catch (error) {
// 			alert('Axios Error:', error);
// 		  }
	 
// 	} catch (error) {
// 	  alert(error);
// 	}
//   };
const Info = (props) => {

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const user_id = urlParams.get('uid');

	return( 
		           
			<View style={styles.container}>
				<Text style={styles.text}></Text>
                <Text style={styles.text}>Social Media Post Translation Experiment</Text>
                <Text style={styles.text4}>This experiment is being conducted by Dr. Bart Knijnenburg and his team at Clemson University. </Text> 
                <View style={styles.imageContainer}>
                <View style={styles.textContainer}> 
                <Text style={styles.text3}>   We are developping a tool that has a new post translation feature. </Text>
                <Text style={styles.text2}>    What will you do?</Text>
                <Text style={styles.text3}>   - You will receive two prompts to write social media posts/status updates. </Text>
                <Text style={styles.text3}>   - Please write both posts in a language other than English. </Text>
                <Text style={styles.text3}>   - After that we will ask you to share your feedback about your experience of using the new post translation feature.</Text>
               </View>
                <Image source ={imgSrc} style={{width:340,height:300,resizeMode: 'stretch',justifyContent: 'center',borderWidth: 1, }}/>
                
                </View>
                
                <Text style={styles.text4}>Your participation will help advance the cause of science.</Text> 
                <Text style={styles.text4}>If you are interested in participating, please press 'START' button to begin the experiment</Text>
            
                  <View style={styles.buttonContainer}>

                <Button 
                color='#341ada'
                title="Start"
                style={StyleSheet.buttonStyle}
                onPress={() => {
				//	translateText ();

					props.navigation.navigate('Infoo',{uid:user_id});}}
			   //onPress={() => {writeUserData(123,'Hi Hi we did it!',new Date().toString())}}
				> 
                </Button>
				</View>
                
			</View>
       
    )
}
//<Text style={styles.text3}>   You will write each post using our tool. </Text>
                
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
        backgroundColor:'#D3D3D3',
		justifyContent: "center",
	},
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'left',
        flexDirection: "column",
		justifyContent: "center",
	},
	buttonContainer:{
		width: '20%',
		alignSelf: 'center',
		marginVertical: 20,
	},

	text: {
		fontWeight: "bold",
		fontSize: 40
	},
    text2: {
		fontWeight: "bold",
		fontSize: 20,
        marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'left',
	},
    text3: {
		//fontWeight: "bold",
		padding: 10,
		fontSize: 18,
	},
    
    text4: {
		//fontWeight: "bold",
		padding: 30,
		fontSize: 18,
	},
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:270,
		paddingLeft: 270,
		paddingBottom: 30,

	  },
	  textArea: {
		height: 300,
		fontSize: 20,
		borderColor: '#341ada',
		borderWidth: 3,
		justifyContent: "flex-start"
	  }
})
export default Info